import { render } from "./HeroiconsOutlineArrowCircleLeft.vue?vue&type=template&id=7c224ebc"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowCircleLeft.vue"]])

export default __exports__